/** Minimal class-name joiner. No dependency, no clsx, no tailwind-merge. */
export function cn(...parts: ReadonlyArray<string | false | null | undefined>): string {
  return parts.filter((p): p is string => typeof p === 'string' && p.length > 0).join(' ');
}
